import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChatPageComponent } from './components/chat-page/chat-page.component';
import { FormModalComponent } from './components/form-modal/form-modal.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/messages',
    pathMatch: 'full'
  },
  {
    path: 'options',
    component: FormModalComponent
  },
  // No conversation id yet - AppComponent.restoreConversation() takes it from here and
  // navigates to a real conversation (the previously open one if it still exists, otherwise
  // the first one in the Chat tab).
  {
    path: 'messages',
    component: ChatPageComponent
  },
  {
    path: 'messages/:id',
    component: ChatPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
